export default __webpack_public_path__ + "static/media/liederland-swissmom-special.43c86b36.png";